module.exports = __webpack_public_path__ + "img/Empty.cbcc33ab.png";